// Píldoras de la lista y de la ficha: decisión, nivel y la marca de evaluación contradictoria.
// SCI y Nivel son dos cosas distintas y nunca se fusionan en una sola píldora.
import { AlertTriangle } from 'lucide-react';
import { ClientLevelEnum } from '@fiado/type-kit/bin/loanScoring/enums/ClientLevelEnum';
import { ScoringDecisionEnum } from '@fiado/type-kit/bin/loanScoring/enums/ScoringDecisionEnum';
import { cn } from '@/lib/cn';
import { CLIENT_LEVEL_LABEL, SCORING_DECISION_LABEL } from '../logic';

const PILL =
    'inline-flex items-center rounded-full px-[7px] py-px text-[9.5px] font-bold whitespace-nowrap';

const DECISION_CLASS: Record<ScoringDecisionEnum, string> = {
    [ScoringDecisionEnum.APPROVED]: 'bg-success/15 text-success',
    [ScoringDecisionEnum.NO_ELIGIBLE]: 'bg-warning/15 text-warning',
    [ScoringDecisionEnum.REJECTED]: 'bg-destructive/15 text-destructive',
};

const LEVEL_CLASS: Record<ClientLevelEnum, string> = {
    [ClientLevelEnum.GOLD]: 'border-warning text-warning',
    [ClientLevelEnum.SILVER]: 'border-muted-foreground text-muted-foreground',
    [ClientLevelEnum.BRONZE]: 'border-info text-info',
    [ClientLevelEnum.NOT_ELIGIBLE]: 'border-destructive text-destructive',
};

export function DecisionPill({
    decision,
    size = 'sm',
}: {
    decision: ScoringDecisionEnum;
    size?: 'sm' | 'md';
}) {
    return (
        <span
            className={cn(
                PILL,
                DECISION_CLASS[decision],
                size === 'md' && 'px-2.5 py-0.5 text-[11px]',
            )}
        >
            {SCORING_DECISION_LABEL[decision]}
        </span>
    );
}

export function LevelPill({ level, size = 'sm' }: { level: ClientLevelEnum; size?: 'sm' | 'md' }) {
    return (
        <span
            className={cn(
                PILL,
                'border font-semibold',
                LEVEL_CLASS[level],
                size === 'md' && 'px-2.5 py-0.5 text-[11px]',
            )}
        >
            {CLIENT_LEVEL_LABEL[level]}
        </span>
    );
}

/** Marca visible en la fila: esta evaluación se contradice a sí misma y hay que mirarla. */
export function ContradictionMark({ title }: { title: string }) {
    return (
        <span
            title={title}
            className="inline-flex items-center gap-1 rounded bg-destructive/15 px-1.5 py-px text-[9px] font-bold uppercase tracking-[0.04em] text-destructive"
        >
            <AlertTriangle className="size-2.5" aria-hidden />
            Inconsistente
        </span>
    );
}
